import Vue from "vue";
import Vuex from "vuex";
import VuexPersistance from "vuex-persist";
import axios from "../src/config";

Vue.use(Vuex);
const vuexLocal = new VuexPersistance({
  storage: window.localStorage
});
export default new Vuex.Store({
  state: {
    userAccount: {
      userName: "",
      password: "",
      role: ""
    },
    itemList: []
  },
  plugins: [vuexLocal.plugin],
  mutations: {
    updateUserAccount: function(state, value) {
      state.userAccount = value;
      if (value.password != undefined) {
        axios.defaults.headers.common[
          "Authorization"
        ] = `DELI    ${value.password}`;
      } else {
        axios.defaults.headers.common["Authorization"] = `DELI ''''''`;
      }
    },
    removeUserAccount: function(state) {
      state.userAccount = {};
    },
    addItem: function(state, value) {
      state.itemList.push(value);
      //state.itemList = [...new Set(state.itemList)];
    },
  },
  actions: {}
});
